import Fade from "react-reveal/Fade";
import JoinOurTeam from "../common/JoinOurTeamCTA";
import CustomNextImage from "../common/CustomNextImage";

const TeamHero = () => {
  return (
    <section className="relative md:pb-0 md:h-[56.25vw] md:max-h-[calc(100vh-60px)] lg:bg-cover lg:bg-center lg:w-full">
      {/* Tab & Desktop  view */}
      <div className="hidden md:block">
        <div className="inset-0 bg-gradient-to-b from-black/0 via-black/0 to-black/100 z-10 md:absolute" />
        <div className="w-full">
          <CustomNextImage
            src="/assets/teams/team-photo-desktop.webp"
            alt="seekho-team"
            fill
            priority
            className="object-cover"
          />
        </div>
        <div className="z-10 w-fit mx-auto md:absolute left-0 right-0 md:!bottom-0 lg:!bottom-24">
          <Fade bottom>
            <h6 className="w-full text-center mx-auto font-lexend font-semibold z-20 leading-[110%] md:text-[25px] lg:text-[48px]">
              Make Learning Fun And Easy For Everyone
            </h6>
          </Fade>
          <Fade bottom delay={400}>
            <h6 className="w-[70%] text-center mx-auto font-lexend mt-4 leading-[32px] md:text-[18px] lg:text-[20px]">
              Where growth, learning, and great people come together
            </h6>
          </Fade>
          <Fade bottom delay={600}>
            <div className="mx-auto mt-8">
              <JoinOurTeam
                desktopStatus="hero_cta"
                arrowClass="text-[20px] lg:text-[24px]"
                ctaClassName="mx-auto leading-[24px] h-[56px] w-[242px] !px-8 md:!px-6 md:!py-2 md:!text-[18px] lg:!py-3 lg:!text-[20px]"
              />
            </div>
          </Fade>
        </div>
      </div>

      {/* Mobile View */}
      <div className="block min-h-screen pb-3 md:hidden">
        <div className="py-7" />
        <div className="relative">
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/100 via-black/0 to-black/100 z-10" />
          <div className="block min-h-[35vh] lg:hidden">
            <CustomNextImage
              src="/assets/teams/team-photo-mobile.webp"
              alt="team-hero-bg"
              width={1500}
              height={1000}
              priority
            />
          </div>
        </div>
        <div>
          <Fade bottom>
            <h6 className="text-[24px] text-center w-[90%] mx-auto mt-[50px] font-lexend font-semibold leading-[32px]">
              Make Learning Fun And Easy For Everyone
            </h6>
          </Fade>
          <Fade bottom delay={500}>
            <h6 className="text-[14px] text-center w-[80%] mx-auto leading-[18px] font-lexend mt-5">
              Where growth, learning, and great people come together
            </h6>
          </Fade>
          <Fade bottom delay={600}>
            <JoinOurTeam
              mobileStatus="hero_cta"
              ctaClassName="!w-[200px] mx-auto mt-10"
            />
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default TeamHero;
